/**
 * Kick off a Stripe Premium subscription checkout.
 *
 * Stripe checkout redirects to an external Stripe-hosted URL, so this must be a
 * native form POST (not fetch) — mirrors the legacy `_premium_form.html` and the
 * Settings > Premium page. Shared by the Settings page and the premium upsell
 * modal so the checkout contract lives in one place.
 */
export interface StripeCheckoutParams {
  plan: 'monthly' | 'yearly';
  formKey: string;
  /** Where Stripe returns the user after a successful checkout. Defaults to the
   *  current page so upsells return the user where they started. */
  successUrl?: string;
}

export function submitStripeCheckout({
  plan,
  formKey,
  successUrl = window.location.href,
}: StripeCheckoutParams): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/user/stripe/checkout';

  const fields: Record<string, string> = {
    form_key: formKey,
    // Stripe checkout expects the selected plan as a truthy `monthly`/`yearly` flag.
    [plan]: '1',
    success_url: successUrl,
  };

  for (const [name, value] of Object.entries(fields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
}
